import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiClient, provisioningPath } from '@/lib/api-client';
import type { PaginatedTasks, TaskHistoryQuery } from '@/types/provisioning';

import { provisioningKeys } from './provisioning-keys';

/**
 * GET /api/admin/provisioning/tasks — the paginated task-history audit list.
 * Polls every 15s so a freshly-run task appears without a manual refresh.
 */
export function useTaskHistory(
  query: TaskHistoryQuery,
): UseQueryResult<PaginatedTasks, Error> {
  return useQuery({
    queryKey: provisioningKeys.taskHistory(query),
    queryFn: ({ signal }) =>
      apiClient.get<PaginatedTasks>(provisioningPath('/tasks', query), signal),
    placeholderData: keepPreviousData,
    refetchInterval: 15_000,
    refetchIntervalInBackground: false,
  });
}
